import { TableRow, TableCell, Stack, Box } from "@mui/material";
import { SurveyQuestionAnswerInfo } from "../../redux/survey/surveyQuestionAnswerListSlice";
import { useAppDispatch } from "../../app/hooks";
import { useSelector } from "react-redux";
import { getOrRetrieveNamedObject, selectObjectCache } from "../../redux/object/objectCacheSlice";
import { ObjectTarget } from "../../app/permissions";
import BadgedAvatar from "../base/BadgedAvatar";
import { SurveyQuestionInfo } from "../../redux/survey/surveySlice";

interface SurveyResultRowProps {
    answer: SurveyQuestionAnswerInfo;
    question: SurveyQuestionInfo;
}

const SurveyResultRow = ({ answer, question }: SurveyResultRowProps) => {
    const dispatch = useAppDispatch();
    const cache = useSelector(selectObjectCache);

    const wasAnswered = answer.surveyQuestionOptionId != undefined;
    const color = (theme: any) => wasAnswered ? theme.palette.success : theme.palette;

    const student = getOrRetrieveNamedObject(dispatch, cache, ObjectTarget.STUDENT, `${answer.studentId}`);
    const user = getOrRetrieveNamedObject(dispatch, cache, ObjectTarget.USER, `${answer.userId}`);

    const option = question.options?.find((opt) => answer.surveyQuestionId == question.id && opt.id === answer.surveyQuestionOptionId);

    return (
        <TableRow key={answer.id}>
            <TableCell align="left" sx={{ 
                // backgroundColor: (theme) => color(theme).contrastText,
                borderLeft: (theme) => `1px solid ${color(theme).main}`,
                color: (theme) => color(theme).main,
            }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <BadgedAvatar key={answer.id}
                        title={`${student?.display ?? answer.studentId}`} 
                        avatar={student?.image} 
                        size={"25px"}
                        fontSize="12px"
                    />
                    <Box>
                        {student?.display ?? answer.studentId}
                    </Box>
                </Stack>
            </TableCell>
            <TableCell align="left" sx={{ 
                // backgroundColor: (theme) => color(theme).contrastText,
                borderLeft: (theme) => `1px solid ${color(theme).main}`,
                color: (theme) => color(theme).main,
            }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <BadgedAvatar key={answer.id}
                        title={`${user?.display ?? answer.userId}`} 
                        avatar={user?.image} 
                        size={"25px"}
                        fontSize="12px"
                    />
                    <Box>
                        {user?.display ?? answer.userId}
                    </Box>
                </Stack>
            </TableCell>
            <TableCell align="left" sx={{ 
                // backgroundColor: (theme) => color(theme).contrastText,
                borderLeft: (theme) => `1px solid ${color(theme).main}`,
                color: (theme) => color(theme).main,
            }}>{option?.title ?? "-"}</TableCell>
        </TableRow>
    );
};

export default SurveyResultRow;
